import { getFormattedPeriod } from 'packages/common/utils/format';
import { returnFileFromResponse, downloadFile } from 'packages/common/utils/file';
import resource from '../resource';

export function getMovementFiles(selectedDate) {
  const period = getFormattedPeriod(selectedDate);
  return resource.getMovementFiles(period).then(response => response.data);
}

export function editMovementFiles(selectedDate, company) {
  const period = getFormattedPeriod(selectedDate);
  return resource.editMovementFiles(period, company)
    .then(returnFileFromResponse)
    .then(response => downloadFile(response.file, response.fileName));
}
